import ObjectiveService from 'src/modules/objective/objectiveService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import issuesListActions from 'src/modules/issues/list/issuesListActions';
import CompanyService from 'src/modules/company/companyService';
import InitiativeService from 'src/modules/initiative/initiativeService';

const prefix = 'OBJECTIVE_FORM';

const objectiveFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id, company?, initiative?, category?) => async (dispatch) => {
    try {
      dispatch({
        type: objectiveFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ObjectiveService.find(id);
      } else {
        if (company)
          record['company'] = await CompanyService.find(company);
        if (initiative) 
        record['initiative'] = await InitiativeService.find(initiative);
        if (category)
          record['category'] = category;
      }

      dispatch({
        type: objectiveFormActions.INIT_SUCCESS,
        payload: record,
      });

      dispatch(issuesListActions.doFetchAll());

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objectiveFormActions.INIT_ERROR,
      });
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: objectiveFormActions.CREATE_STARTED,
      });

      await ObjectiveService.create(values);

      dispatch({
        type: objectiveFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.objective.create.success'),
      );

      if (getHistory().location.search.includes('initiative')) {
        getHistory().push('/initiative/' + getHistory().location.search.split('=')[1]);
      } else {
        getHistory().push('/objective');
      } 

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objectiveFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: objectiveFormActions.UPDATE_STARTED,
      });

      await ObjectiveService.update(id, values);

      dispatch({
        type: objectiveFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.objective.update.success'),
      );

      getHistory().push('/objective');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objectiveFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default objectiveFormActions;
